import React from "react";
import { LucideIcon } from "lucide-react";
import "./VFontIcon.css";

export type IVFontIconProps = {
    icon: LucideIcon;
    color?: string;
    border?: boolean;
    style?: React.CSSProperties;
    className?: string;
    size?: number;
    spin?: boolean;
    pulse?: boolean;
    title?: string;
    onClick?: () => void;
};

const VFontIcon: React.FC<IVFontIconProps> = (props) => {
    const iconSize = props.size || 16; // Default size
    const IconComponent = props.icon;

    const iconStyle: React.CSSProperties = {
        ...props.style,
        color: props.color,
        border: props.border ? "1px solid currentColor" : undefined,
    };

    const className = [
        "v-font-icon",
        props.spin ? "v-font-icon-spin" : "",
        props.pulse ? "v-font-icon-pulse" : "",
        props.className || "",
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <span onClick={props.onClick} title={props.title} className={className}>
            <IconComponent size={iconSize} style={iconStyle} />
        </span>
    );
};

export default VFontIcon;
